import { useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG'
import { set } from 'date-fns'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { Hand, Trash, Trash2 } from 'lucide-react'
import { AvailableTableFilters } from './DynamicDataAGTable'
import Toast, { ToastType } from '../../../../utils/toast'
import _ from 'lodash'

type CustomFilterProps = {
  filters: AvailableTableFilters[]
  onFilterSelect: Function
  saveFilter: Function
  removeFilter: Function
  currentFilterState: object
  tableName: string
  tableId: number
}
export function CustomFilterComponent(props: CustomFilterProps) {
  const [newFilterName, setNewFilterName] = useState<string>('')
  const [selectedFilter, setSelectedFilter] = useState<AvailableTableFilters>()
  const [existingFilters, setExistingFilters] = useState<AvailableTableFilters[]>()

  function HandleCloseActionMenu() {
    const dropdownElement = document.querySelector(
      '[data-kt-menu-trigger="click"]'
    ) as HTMLButtonElement
    if (dropdownElement) {
      dropdownElement.click()
    }
    setNewFilterName('')
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 50)
  }, [props.filters])

  // Reset filter name when menu closes
  useEffect(() => {
    const handleMenuClose = () => {
      setNewFilterName('')
    }

    // Listen for clicks outside the menu to reset filter name
    const handleClickOutside = (event: MouseEvent) => {
      const menuElement = document.querySelector('[data-kt-menu="true"]')
      const triggerElement = document.querySelector('[data-kt-menu-trigger="click"]')

      if (
        menuElement &&
        triggerElement &&
        !menuElement.contains(event.target as Node) &&
        !triggerElement.contains(event.target as Node)
      ) {
        setNewFilterName('')
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  // Check if any filter is currently applied and update selectedFilter accordingly
  useEffect(() => {
    if (props.currentFilterState && Object.keys(props.currentFilterState).length > 0) {
      // Find the filter that matches the current filter state and belongs to this table
      const matchingFilter = props.filters?.find(
        (filter) =>
          filter.tableName === props.tableName &&
          _.isEqual(filter.filterState, props.currentFilterState)
      )
      if (matchingFilter) {
        setSelectedFilter({ ...matchingFilter, isSelected: true })
      } else {
        // No matching filter found for this table, clear selection
        setSelectedFilter(undefined)
      }
    } else {
      // No filters applied, clear selected filter
      setSelectedFilter(undefined)
    }
  }, [props.currentFilterState, props.filters, props.tableName])

  const onFilterSelected = (filter: AvailableTableFilters) => {
    setSelectedFilter(() => filter)
    props.onFilterSelect(filter)
    HandleCloseActionMenu()
  }
  const handleReset = () => {
    setSelectedFilter(undefined)
    props.onFilterSelect(null)
    HandleCloseActionMenu()
  }

  const removeFilter = (filterName: string) => {
    props.onFilterSelect(null)
    setSelectedFilter(undefined)
    props.removeFilter({
      tableId: props.tableId,
      filterName: filterName,
      tableName: props.tableName,
    })
    HandleCloseActionMenu()
  }

  const saveNewFilter = () => {
    if (Object.keys(props.currentFilterState).length === 0) {
      Toast('No Filter exists to save', ToastType.error)
      return
    }
    if (
      existingFilters?.some((filter) => _.isEqual(filter.filterState, props.currentFilterState))
    ) {
      Toast('Same filter already exists', ToastType.error)
      return
    }
    if (
      existingFilters?.some(
        (availableFilters) =>
          availableFilters.filterName?.toLowerCase() === newFilterName?.toLowerCase()
      )
    ) {
      Toast('Filter with same name already exists', ToastType.error)
      return
    }
    if (newFilterName) {
      props.saveFilter({
        tableId: props.tableId,
        filterName: newFilterName,
        filterState: props.currentFilterState,
        tableName: props.tableName,
      })
      HandleCloseActionMenu()
    } else {
      Toast("Please enter Filter's name", ToastType.error)
    }
  }

  const actionMenu = () => {
    return (
      <div className='d-flex flex-column h-auto'>
        <div>
          <p className='text-growth-card d-flex align-items-center justify-content-center mb-0 fs-5 fw-bold'>
            Your Saved Filter
          </p>
          <hr className='mt-1 text-growth-card' />

          {existingFilters && existingFilters?.length > 0 ? (
            <ul className='list-group px-2 min-h-100px mh-150px overflow-auto'>
              {existingFilters?.map((filter: any) => (
                <li
                  key={filter.id}
                  className='list-group-item d-flex align-items-center justify-content-between cursor-pointer'
                  onClick={() => onFilterSelected({ ...filter, isSelected: true })}
                >
                  <span
                    className={`mb-0 fs-6 ${
                      filter.id === selectedFilter?.id ? 'text-primary fw-bold' : 'text-growth-card'
                    }`}
                    style={{ cursor: 'pointer' }}
                  >
                    {filter.filterName}
                  </span>

                  {selectedFilter?.id !== filter.id && (
                    <Trash2
                      size={14}
                      className='text-gray-500 cursor-pointer text-hover-danger'
                      onClick={() => removeFilter(filter.filterName)}
                    />
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className='min-h-100px mh-150px d-flex justify-content-center text-muted align-items-center'>
              -- No saved filters found --
            </p>
          )}
        </div>

        <hr />
        <div className='px-2'>
          <input
            type='text'
            className='form-control custom-input fw-bold shadow-lg h-38px'
            placeholder='Enter filter name'
            value={newFilterName}
            onChange={(e) => setNewFilterName(e.target.value)}
            autoComplete='off'
          />
        </div>

        <div className='row p-2'>
          <div className='col-6 pe-2'>
            <button
              className='w-100 px-4 rounded border border-1 bg-transparent border-gray-500 h-38px fw-normal text-gray-800 bg-hover-secondary'
              onClick={() => {
                handleReset()
              }}
            >
              <span className='indicator-label'>Reset</span>
            </button>
          </div>

          <div className='col-6 ps-2'>
            <button
              type='submit'
              className={`w-100 px-4 rounded border border-0 h-38px fw-normal ${
                newFilterName.trim()
                  ? 'border-primary bg-primary text-white'
                  : 'border-light-primary bg-light-primary text-gray-600 disabled'
              }`}
              disabled={!newFilterName.trim()}
              onClick={() => {
                saveNewFilter()
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='px-0'>
      <style>
        {`
          .dot {
            height: 8px;
            width: 8px;
            background-color: #dc3545;
            border-radius: 50%;
            display: inline-block;
            margin-left: 1px;
            position: relative;
            top: -8px;
          }
        `}
      </style>
      <button
        type='button'
        className={`px-4 rounded border border-1 border-secondary-txt  bg-transparent h-38px fw-normal ms-4 text-growth-card`}
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='top-end'
        data-bs-toggle='dropdown'
        onClick={() => {
          const filteredData = props.filters?.filter((item) => item.tableName === props.tableName)
          setExistingFilters(filteredData)
        }}
      >
        <KTSVG
          path='/media/icons/duotune/general/gen031.svg'
          className={`svg-icon-3 text-secondary-txt`}
        />{' '}
        Custom Filters
        {selectedFilter?.isSelected && <span className='dot'></span>}
      </button>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px pt-2 mt-1 border border-1 border-gray-400 shadow-sm'
        data-kt-menu='true'
        style={{
          boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
          border: '1',
          borderColor: '#F1F1F2',
          height: '300px',
        }}
      >
        {actionMenu()}
      </div>
    </div>
  )
}
